import { environment } from '@ag2-weathermaker/shared/environments/environment';
import { WeathermakerForecastTypes } from './publishing-center.types';
export const API_URL = environment.apiUrl;
export const endpoints = {
  editableSites: 'editable-sites',
  forecastSources: 'fcst-sources',
  staticSites: 'static-data/sites',
  staticNormals: 'static-data/normals',
  forecastData: 'fcst-data/', // this takes in a site id at the end
  saveAsSource: 'exports/save-fcst-as-source',
  publishHistory: 'exports/publish-history',
  savedSources: 'fcst-sources/saved-sources',
  savedSourceData: 'fcst-data/saved-source', // this takes in a source id at the end
  createGraphics: 'exports/create-graphics',
  isUserAllowed: 'allowed',
  userSegmentData: 'user-segment-data',
  subRegionToSitesMappingData: 'subregion-sites-mapping-table',
  releaseNotes: 'release-notes',
  releaseNotesUpdateSeenStatus: 'release-notes/update-seen-status',
  releaseNotesHasViewed: 'release-notes/has-viewed',
  releaseNotesYears: 'release-notes/years',
  dailyObs: 'daily-obs',
  dailyEC46: 'daily-ec46',
  customFilters: 'custom-filters',
  customFilterCities: 'custom-filter-cities',
};

export const FORECAST_RANGE_VARIABLES = {
  shortRange: 'shortRange',
  subseasonal: 'subseasonal',
};
export interface EditableSitesResponse {
  editable_site_ids: string[];
}

export interface ForecastSourceResponse {
  id: string;
  type: string;
  init_time: string;
  forecast_type_label: string;
  url: string;
  start_date_utc: string;
  end_date_utc: string;
}

export interface SavedForecastSourceResponse {
  id: number;
  forecast_label: string;
  init_time: string;
  type: WeathermakerForecastTypes.WM_SAVED_SOURCE;
}

export interface UserSegmentDataResponse {
  username: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  organizationName: string;
}

export interface SubRegionToSitesMappingDataResponse {
  siteId: string;
  region: string;
  subRegionDisplayName: string;
  isEiaRegion: boolean;
  sortOrderId: number | null;
}

export interface ReleaseNotesApiResponse {
  feature_id: number;
  id: number;
  storage_time: string;
  release_note_id: number;
  title: string;
  text: string;
  updated_at: string;
  release_date: string;
  is_published: number;
  future_display_time: string;
  is_displayed_in_future: boolean;
}

export interface ReleaseNoteGroup {
  day: string;
  notes: ReleaseNotesApiResponse[];
  hasDraft: boolean;
  releaseInFuture: boolean;
  futureReleaseDate: string | null;
}

export interface DailyObsResponse {
  site_id: string;
  valid_date: string;
  min_temp: number;
  max_temp: number;
}

export interface CustomFilterItem {
  id: number;
  list_name: string;
}

export interface CustomFilterCityItem {
  site_id: string;
  list_order: number | null;
  list_name: string;
  list_id: number;
}
